import { Row, Col, Button, Input, Form, notification, message } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";

import "react-quill/dist/quill.snow.css";
import endpoints from "../../utils/endpoints.js";

function SettingsVersion({ data }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (data.length > 0) {
      let auxData = Object.assign([], data).filter((item) => item.name === "version")[0];
      form.setFieldsValue(JSON.parse(auxData.json));
    }
  }, [data]);

  function handleSubmit(values) {
    setIsButtonLoading(true);

    axios
      .post(endpoints.settings.update, {
        data: { values, name: "version" },
      })
      .then((resData) => {
        setIsButtonLoading(false);
        message.success("Definições foram editadas com sucesso!");
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function handleWarningMissingFields() {
    message.error("Faltam alguns campos para preencher!");
  }

  return (
    <div className="dashboard-page">
      <div className="dashboard-content-row">
        <Form form={form} id="add-commission_type-form" layout="vertical" onFinish={handleSubmit} onFinishFailed={handleWarningMissingFields}>
          <Form.Item hidden name="id">
            <Input />
          </Form.Item>
          <div className="grid grid-cols-2 gap-8">
            <Form.Item label="Versão iOS" name={"iOS"}>
              <Input size="large" />
            </Form.Item>
            <Form.Item label="Versão Android" name={"android"}>
              <Input size="large" />
            </Form.Item>
          </div>
          <Button type="primary" size="large" onClick={form.submit} loading={isButtonLoading}>
            Guardar
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default SettingsVersion;
